import script from "./TheGroupManager.vue?vue&type=script&setup=true&lang=js"
export * from "./TheGroupManager.vue?vue&type=script&setup=true&lang=js"

import "./TheGroupManager.vue?vue&type=style&index=0&id=03558216&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03558216"]])

export default __exports__